import { Box, Breadcrumbs, Button, Paper, TextField, Typography, TableContainer, Table, TableHead, TableRow, TableCell, TableSortLabel, TableBody, IconButton, Tooltip, FormControl, InputLabel, Select, MenuItem, Stack, Chip } from '@mui/material'
import React, { useContext, useEffect, useState } from 'react'
import { Link, useParams, useNavigate, useLocation } from 'react-router-dom'
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import SourceIcon from '@mui/icons-material/Source';
import { useSelector } from 'react-redux';
import { reset, init, save, updateGenerales, onDeleteDS, toggleDeleteTokenDialog, onDeleteToken, deleteProject, addTag, deleteTag } from './edit-project-actions';
import DeleteIcon from '@mui/icons-material/Delete';
import ConfirmDialog from '../../template/ConfirmDialog';
import AddIcon from '@mui/icons-material/Add';
import KeyIcon from '@mui/icons-material/Key';
import AppContext from '../../state/AppContext';
import { createTextKey } from '../../utils/StringUtils';
import HomeOutlinedIcon from '@mui/icons-material/HomeOutlined';
import Header from '../../template/Header';
import WorkspacePremiumIcon from '@mui/icons-material/WorkspacePremium';
import DocumentVerificationMethod from './DocumentVerificationMethod';
import GrantContent from '../../template/GrantContent';
import * as Permissions from '../../utils/Permissions';
import RocketLaunchIcon from '@mui/icons-material/RocketLaunch';
import EditProjectHighFrequency from './EditProjectHighFrequency';
import MonitorHeartIcon from '@mui/icons-material/MonitorHeart';
import EditProjectHealthCheck from './EditProjectHealthCheck';

const columns = [
    {
        field: 'name',
        headerName: 'Name'
    }, {
        field: 'expiration',
        headerName: 'Expiration'
    }, {
        field: '',
        headerName: 'Actions',
        type: 'string'
    }
]

const tabs = {
    "general": 0,
    "api-token": 1,
    "doc-verification": 2,
    "high-frequency": 3,
    "health-check": 4,
    "delete": 5
}

const EditProject = (props) => {

    const location = useLocation();
    const state = useSelector(state => state.pages.editProject)
    const { appContext } = useContext(AppContext)
    const { project } = useParams()
    const [tab, setTab] = useState(tabs[new URLSearchParams(location.search).get('tab')] || 0)
    const navigate = useNavigate()

    useEffect(() => {
        if (project !== "_new") {
            init(project)
        }

        return () => reset()
    }, [project])

    const changeTab = (event, newValue) => {
        setTab(newValue);
    };

    return (
        <div className="">
            <Header title={<span>{project}{state.new ? "*" : ""}</span>}>
                <Breadcrumbs aria-label="breadcrumb" separator="/" className="!text-gray-600">
                    <Typography ><HomeOutlinedIcon className="text-gray-600" fontSize="small" /></Typography>
                    <Typography ><span className="text-gray-600">Projects</span></Typography>
                    <Typography ><span className="text-gray-600">{project}</span></Typography>
                </Breadcrumbs>
            </Header>
            <ConfirmDialog title="Delete token" message="This action is permanent and there will be no way to recover the token" open={state.showDeleteDialog.open} onClose={toggleDeleteTokenDialog} onConfirm={() => onDeleteToken(project)} />
            <div className="content grid gap-8">
                <div className="grid gap-8" >
                    <Box sx={{ width: '100%' }}>
                        <Paper sx={{ width: '100%' }}>
                            <Box sx={{ width: '100%' }}>
                                <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                                    <Tabs value={tab} onChange={changeTab} aria-label="basic tabs example">
                                        <Tab label="General" icon={<SourceIcon />} iconPosition="start" />
                                        <Tab label="API Token" icon={<KeyIcon />} iconPosition="start" disabled={state.new} />
                                        <Tab label="Doc. Verification" icon={<WorkspacePremiumIcon />} iconPosition="start" disabled={state.new} />
                                        <Tab label="High Frequency" disabled={state.new} icon={<RocketLaunchIcon />} iconPosition="start" />
                                        <Tab label="Health Check" disabled={state.new} icon={<MonitorHeartIcon />} iconPosition="start" />
                                        <Tab label="Delete" icon={<DeleteIcon />} iconPosition="start" disabled={state.new} />
                                    </Tabs>
                                </Box>
                            </Box>

                            {tab === 0 && (
                                <div>
                                    <div className="grid gap-4 p-4">
                                        <TextField
                                            size="medium"
                                            name="name"
                                            label="name"
                                            fullWidth={false}
                                            className="w-[500px]"
                                            disabled={!state.new}
                                            value={state.name}
                                            onInput={event => createTextKey(event, 60)}
                                            onChange={updateGenerales}
                                        />

                                        <div className="flex gap-4 w-[500px]">
                                            <TextField
                                                size="medium"
                                                name="tag"
                                                className="flex-1"
                                                label="Add Tags"
                                                fullWidth={false}
                                                onInput={event => createTextKey(event, 60)}
                                                onChange={updateGenerales}
                                                value={state.tag}
                                            />

                                            <Select
                                                size="small"
                                                className="w-24"
                                                name="tagColor"
                                                value={state.tagColor || "gray"}
                                                onChange={updateGenerales}
                                            >
                                                <MenuItem value="gray"><div className={`!w-[18px] !h-[18px] rounded-full !bg-gray-500`} /></MenuItem>
                                                <MenuItem value="red"><div className={`!w-[18px] !h-[18px] rounded-full !bg-red-500`} /></MenuItem>
                                                <MenuItem value="blue"><div className={`!w-[18px] !h-[18px] rounded-full !bg-blue-500`} /></MenuItem>
                                                <MenuItem value="green"><div className={`!w-[18px] !h-[18px] rounded-full !bg-green-500`} /></MenuItem>
                                                <MenuItem value="yellow"><div className={`!w-[18px] !h-[18px] rounded-full !bg-yellow-500`} /></MenuItem>
                                                <MenuItem value="orange"><div className={`!w-[18px] !h-[18px] rounded-full !bg-orange-500`} /></MenuItem>
                                            </Select>

                                            <Button variant="contained" onClick={addTag}>Add</Button>
                                        </div>



                                        <Stack direction="row" spacing={1}>
                                            {state.tags.map(tag => (
                                                <Chip key={tag.name} avatar={<div className={`!w-[18px] !h-[18px] rounded-full !bg-${tag.color}-500`} />} label={tag.name} variant="outlined" onDelete={(e) => deleteTag(tag)} />
                                            ))}
                                        </Stack>

                                    </div>
                                    <div className="p-4 text-right bg-gray-100 border-t border-gray-300">
                                        <Button variant="contained" className="text-dark-500" onClick={() => save(project, navigate)}>SAVE</Button>
                                    </div>
                                </div>
                            )}

                            {tab === 1 && (
                                <div className="grid gap-8 p-4">
                                    <div className="text-right">
                                        <GrantContent permisos={[Permissions.PROJECTS_TOKENS_W]}>
                                            {(canAccess, roles, permisos, isPage) => (
                                                <Tooltip title={canAccess ? "Create a new token" : `You don't have permission to create a new token, required permissions: ${permisos.join(", ")}`}>
                                                    <span>
                                                        <Button disabled={!canAccess} variant="contained" LinkComponent={Link} to={`/projects/${project}/tokens/new`}><AddIcon /> NEW TOKEN</Button>
                                                    </span>
                                                </Tooltip>
                                            )}
                                        </GrantContent>
                                    </div>
                                    <Box >
                                        <Paper >
                                            <TableContainer>
                                                <Table sx={{ minWidth: 750 }} aria-labelledby="tableTitle" size={"small"}  >
                                                    <TableHead>
                                                        <TableRow>
                                                            {columns.map((headCell) => (
                                                                <TableCell key={headCell.field} align={'left'} padding={'normal'} >
                                                                    <TableSortLabel >
                                                                        {headCell.headerName}
                                                                    </TableSortLabel>
                                                                </TableCell>
                                                            ))}
                                                        </TableRow>
                                                    </TableHead>
                                                    <TableBody>
                                                        {state.tokens.map((row, index) => {
                                                            return (
                                                                <TableRow
                                                                    hover
                                                                    tabIndex={-1}
                                                                    key={row.id}
                                                                    sx={{ cursor: 'pointer' }}
                                                                >
                                                                    <TableCell align="left">{row.name}</TableCell>
                                                                    <TableCell align="left">{row.expiration ? row.expiration : <em>Never</em>}</TableCell>
                                                                    <TableCell width={130} align="right">
                                                                        <GrantContent permisos={[Permissions.PROJECTS_TOKENS_D]}>
                                                                            {(canAccess, roles, permisos, isPage) => (
                                                                                <Tooltip title={canAccess ? "Delete" : `You don't have permission to delete this token, required permissions: ${permisos.join(", ")}`}>
                                                                                    <span>
                                                                                        <IconButton disabled={!canAccess} onClick={(event) => toggleDeleteTokenDialog(event, row)} ><DeleteIcon className="hover:text-red" /></IconButton>
                                                                                    </span>
                                                                                </Tooltip>
                                                                            )}
                                                                        </GrantContent>
                                                                    </TableCell>
                                                                </TableRow>
                                                            );
                                                        })}
                                                    </TableBody>
                                                </Table>
                                            </TableContainer>
                                        </Paper>
                                    </Box>
                                </div>
                            )}

                            {tab === 2 && (
                                <DocumentVerificationMethod />
                            )}
                            {tab === 3 && (
                                <EditProjectHighFrequency />
                            )}
                            {tab === 4 && (
                                <EditProjectHealthCheck />
                            )}
                            {tab === 5 && (
                                <form onSubmit={event => deleteProject(event, navigate)}>
                                    <div className="grid gap-4 p-4">
                                        <p>Deleting the project is an irreversible action and will delete all collections, documents, users, tokens, etc.</p>
                                        <TextField
                                            required
                                            size="medium"
                                            name="deleteProjectName"
                                            label="Project name"
                                            className="w-96"
                                            helperText={<p>Enter the project name <em className="text-red">'{state.name}'</em> to confirm the action</p>}
                                            value={state.deleteProjectName}
                                            onInput={event => createTextKey(event, 60)}
                                            onChange={updateGenerales}
                                        />


                                    </div>

                                    <div className="p-4 text-right bg-gray-100 border-t border-gray-300">
                                        <GrantContent permisos={[Permissions.PROJECTS_D]}>
                                            {(canAccess, roles, permisos, isPage) => (
                                                <Tooltip title={canAccess ? "Delete" : `You don't have permission to delete this project, required permissions: ${permisos.join(", ")}`}>
                                                    <span>
                                                        <Button type="submit" className="" variant="contained" color="error" fullWidth={false} disabled={!canAccess}>DELETE</Button>
                                                    </span>
                                                </Tooltip>
                                            )}
                                        </GrantContent>
                                    </div>

                                </form>
                            )}

                        </Paper>
                    </Box>
                </div>
            </div>
        </div>
    )

}


export default EditProject